<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <div style="padding-bottom: 10px;">
          <el-switch v-model="groupOrfacility" active-text="Group" inactive-text="Facility" @change='changeGroupOrfacility'></el-switch>
        </div>
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="200px">
          <el-row>
            <!-- 供应商编码 -->
            <el-col :span="8">
              <el-form-item :label="$t('BC.suppliercodeOrInvitationCode')" prop="invitationSupplierCode">
                <el-input v-model="queryCondition.invitationSupplierCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 供应商简称-->
            <el-col :span="8">
              <el-form-item :label="$t('BC.supplierAbbreviation')" prop="supplierNameShort">
                <el-input v-model="queryCondition.supplierNameShort" clearable></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <!-- 供应商名称-->
            <el-col :span="8">
              <el-form-item :label="$t('BC.supplierAbbreviation')" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 工厂名称-->
            <el-col :span="8" v-if="!groupOrfacility">
              <el-form-item :label="$t('BC.FactoryName')" prop="plantName">
                <el-input v-model="queryCondition.plantName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="10">
                            <el-form-item label="Category1" prop="categoryLevel1Id">
                                <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()">
                                    <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="Category2" prop="categoryLevel2Id">
                                <el-select v-model="queryCondition.categoryLevel2Id" clearable>
                                    <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('BC.search')}}</el-button>
            <el-button @click="restQueryForm();queryCondition.plantName=''" type="primary">{{$t('BC.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('BC.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" row-key="tmSupplierId" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column v-if="multipleSelectionFlag && !groupOrfacility" sortable prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId"></el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('BC.suppliercodeOrInvitationCode')"></el-table-column>
        <!--供应商编码-->
        <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('BC.SupplierName')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierNameShort" :label="$t('BC.supplierAbbreviation')"></el-table-column>
        <!--供应商简称-->
        <el-table-column show-overflow-tooltip prop="plantName" :label="$t('BC.FactoryName')" v-if="!groupOrfacility"></el-table-column>
        <!--工厂名称-->
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import supplierApi from "@/api/supplier/supplier";
import { apiService } from "@/api/material/material-master-data";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";

export default {
  name: 'supplier-sel-page',
  props: {
    tmSupplierId: {
      type: String,
      default: ''
    },
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    }
  },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        invitationSupplierCode: '',
        supplierNameShort: '',
        supplierName: '',
        categoryLevel1Id: '',
        categoryLevel2Id: '',
        pageNum: 1,
        pageSize: 15,
        supperSupplierId: '',
        plantName: '',
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      radioVal: null,
      categoryList1: [],
      categoryList2: [],
      groupOrfacility: false,
    }
  },
  created() {
    this.queryData();
    this.getCategoryList()
  },
  watch: {
    visible() {
      this.$refs.supplierSelectTabel.clearSelection();
    },
    tmSupplierId(val) {
      this.queryData()
    }
  },
  methods: {
    //facility
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      if (that.groupOrfacility) {
        that.queryCondition.status = '1'
        that.queryCondition.auditStatus = 'PASS'
        delete that.queryCondition.supperSupplierId;
        supplierApi.getResourceList(that.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
        })
      } else {
        delete that.queryCondition.status;
        delete that.queryCondition.auditStatus;
        // that.queryCondition.supperSupplierId = that.tmSupplierId
        supplierApi.searchGroupPlant(this.queryCondition).then((res) => {
          that.tableData = res.resultData;
          that.totalCount = res.totalCount;
        })
      }

    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    clickSelectMethod: function () {
      let that = this
      //BC仅可选择唯一供应商
      let arr = this.selectRows
      // this.$emit('groupOrfacility', that.groupOrfacility);
      let flag = true
      if (arr.length > 0) {
        arr.some(function (value, index) {
          if (value.supplierCode !== arr[0].supplierCode) {
            flag = false
          }
        })
      } else {
        this.$emit('subCallMethod', this.selectRows, that.groupOrfacility)
      }
      if (flag) {
        this.$emit('subCallMethod', this.selectRows, that.groupOrfacility)
      } else {
        that.$message({
          message: '仅可选择同一供应商',
          type: "warning"
        });
      }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    changeGroupOrfacility(val) {
      // this.queryCondition.invitationSupplierCode =''
      // this.queryCondition.supplierNameShort =''
      // this.queryCondition.supplierName =''
      // this.queryCondition.categoryLevel1Id =''
      // this.queryCondition.categoryLevel2Id =''
      // this.queryCondition.supperSupplierId =''
      // this.queryCondition.plantName =''
      // this.queryCondition.pageNum =1
      // this.queryCondition.pageSize =10
      this.selectRows = [];
      this.$refs.supplierSelectTabel.clearSelection();
      this.radioVal = null
      this.queryData()
    }
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
